import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from '../../../api';
import { deleteConsultee } from '../methods';
import { EmptyObject } from '../../../types';

export const useDeleteConsultee = (): UseMutationResult<EmptyObject, unknown, number> => {
  const queryClient = useQueryClient();
  return useMutation(deleteConsultee, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getConsultees] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getManageTeamConsultees] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getManageConsultees] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getTQAdmins] });
    },
  });
};
